import { render, staticRenderFns } from "./keyword-dedup-canonical-detail.component.html?vue&type=template&id=d6582ce6&scoped=true&external"
import script from "./keyword-dedup-canonical-detail.component.vue?vue&type=script&lang=ts"
export * from "./keyword-dedup-canonical-detail.component.vue?vue&type=script&lang=ts"
import style0 from "./keyword-dedup-canonical-detail.component.css?vue&type=style&index=0&id=d6582ce6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6582ce6",
  null
  
)

export default component.exports